/**
 *
 * @module accessState
 *
 */

import Check from 'check-types';
import Exception from './../services/exception/entry';
import AccessStateData from './accessStateData';

const InvalidArgumentException = Exception.InvalidArgumentException;

const {
    instanceStrict,
    nonEmptyString
} = Check.assert;

/**
 *
 * @class AccessState
 * @desc Represents the state of the SDK to allow it to be transfered to another device.
 *
 */
export default class AccessState {

    /**
     *
     * @param {String} version
     * @param {AccessStateData} data
     * @throws {InvalidArgumentException}
     *
     */
    constructor(version, data) {

        const errorMessage = {
            ctor: 'AccessState(version, data)',
            get version() {
                return `${this.ctor} version should be a String with length`;
            },
            get data() {
                return `${this.ctor} needs AccessStateData instance`;
            }
        };

        nonEmptyString(version, errorMessage.version, InvalidArgumentException);
        instanceStrict(data, AccessStateData, errorMessage.data, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.version = version;

        /**
         *
         * @access public
         * @type {AccessStateData}
         *
         */
        this.data = data;

    }

}



// WEBPACK FOOTER //
// ./src/token/accessState.js